import React, { useCallback, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import BackToTop from './components/BackToTop';
import MobileCtaBar from './components/MobileCtaBar';
import Home from './pages/Home';
import Cabinet from './pages/Cabinet';
import Services from './pages/Services';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import { ArticlesList, ArticleDetail } from './pages/Articles';
import Reglementaire from './pages/Reglementaire';
import Recrutement from './pages/Recrutement';

const titles = {
  '/': 'Ometis Patrimoine | Gestion de patrimoine indépendante à Paris',
  '/cabinet': 'Le cabinet | Ometis Patrimoine',
  '/services': 'Nos services | Ometis Patrimoine',
  '/actualites': 'Actualités patrimoniales | Ometis Patrimoine',
  '/faq': 'FAQ | Ometis Patrimoine',
  '/contact': 'Contact | Ometis Patrimoine',
  '/reglementaire': 'Cadre réglementaire | Ometis Patrimoine',
  '/nous-rejoindre': 'Nous rejoindre | Ometis Patrimoine'
};

const pageTitle = (pathname) => {
  if (titles[pathname]) return titles[pathname];
  return pathname.startsWith('/actualites/') ? 'Article | Ometis Patrimoine' : 'Ometis Patrimoine';
};

const scrollToHash = (hash) => {
  const target = document.querySelector(hash);
  if (!target) return false;
  setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
  return true;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const syncLocation = useCallback(() => {
    document.title = pageTitle(pathname);
    if (hash && scrollToHash(hash)) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  useEffect(syncLocation, [syncLocation]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cabinet" element={<Cabinet />} />
            <Route path="/services" element={<Services />} />
            <Route path="/actualites" element={<ArticlesList />} />
            <Route path="/actualites/:slug" element={<ArticleDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reglementaire" element={<Reglementaire />} />
            <Route path="/nous-rejoindre" element={<Recrutement />} />
          </Routes>
        </main>
        <Footer />
        <MobileCtaBar />
        <BackToTop />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
